import { unloadUserData, unloadUserInfo } from './user/action'
import { unloadWizard } from './wizard/action'
import { unloadHelpRequest } from './help/action'
import { unloadAdvisorData } from './advisor/unloadadvisordata'
import { unloadReports } from './reports/unloadreports'
import { unloadBMCData } from './bmc/unloadbmc'

export const unloadData = () => dispatch => { 
  dispatch(unloadUserData())
  dispatch(unloadUserInfo())
  dispatch(unloadHelpRequest())
  dispatch(unloadWizard()) 
  dispatch(unloadAdvisorData())
  dispatch(unloadReports())
  dispatch(unloadBMCData()) 
}